import type { Ref } from 'vue'

import type {
  BasePageContent,
  MappedApiPageContent,
} from '@backmarket/http-api/src/api-specs-content/models/base-page-content'

import { PAGE_TYPE_WITH_SPECIFIC_FIELD } from '../service/content-service.config'

export function useIsSpecificLayout(
  data: Ref<MappedApiPageContent<BasePageContent> | null | undefined>,
) {
  if (!data.value) return false

  return PAGE_TYPE_WITH_SPECIFIC_FIELD.includes(data.value.pageType)
}
